import { render, staticRenderFns } from "./devlist.vue?vue&type=template&id=08c080f2&"
import script from "./devlist.vue?vue&type=script&lang=js&"
export * from "./devlist.vue?vue&type=script&lang=js&"
import style0 from "./devlist.vue?vue&type=style&index=0&id=08c080f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports